import {DialogManager} from '@modifi/plugin-dialogs'

import DeleteEntryConfirmDialog, {
  DIALOG_NAME as DIALOG_DELETE_ENTRY_CONFIRM,
} from './delete-entry-confirm-dialog'
import ExitPromptDialog, {DIALOG_NAME as DIALOG_EXIT_PROMPT} from './exit-prompt-dialog'

export {DIALOG_NAME as DIALOG_EXIT_PROMPT} from './exit-prompt-dialog'

DialogManager.addDialog(DIALOG_DELETE_ENTRY_CONFIRM, DeleteEntryConfirmDialog)
DialogManager.addDialog(DIALOG_EXIT_PROMPT, ExitPromptDialog)
